import { Component, Input, OnChanges, Output, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Timeline, DateTimeFrame, Conference, Date, Time, SnackbarService } from '../../../shared';

import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import * as _moment from 'moment';

const moment = _moment.defaultFormat || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-hunt-form',
  templateUrl: 'hunt-form.component.html',
  styleUrls: ['hunt-form.component.scss'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})
export class HuntFormComponent implements OnChanges {
  @Input() 
  huntPreferences: DateTimeFrame;
  @Input() 
  allowedTimelinesCount: number;
  @Output()
  datePicked: EventEmitter<Date> = new EventEmitter();
  @Output()
  search: EventEmitter<Conference> = new EventEmitter();

  form: FormGroup;
  minDate;
  maxDate;
  startTimelines: Timeline[] = [];
  finishTimelines: Timeline[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBarService: SnackbarService,
  ) {
    this.form = this.fb.group({
      date: ['', [Validators.required]],
      startTimeline: ['', [Validators.required]],
      finishTimeline: ['', [Validators.required]]
    });
  }

  ngOnChanges() {
    if (this.huntPreferences) {
      this.updateAllowedDatesRange();
    }
    this.watchForm();
  }

  get date(): Date {
    return new Date(
      this.form.get('date').value.year(),
      this.form.get('date').value.month() + 1,
      this.form.get('date').value.date()
    )
  }

  get startTimelineId(): number {
    return this.form.get('startTimeline').value;
  }

  get finishTimelineId(): number {
    return this.form.get('finishTimeline').value;
  }

  watchForm() {
    this.form.controls['date'].valueChanges.subscribe(() => {
      if (this.form.get('date').value) {
        this.datePicked.emit(this.date);
        this.updateStartTimelines();
  
        if(this.startTimelines.length == 0) {
          this.snackBarService.showNotifation(`hey, ${Time.now().toEastern()} is to late for a conferences`)
        }
      }
    });
    this.form.controls['startTimeline'].valueChanges.subscribe(() => {
      this.updateFinishTimelines();
    });
  }

  updateAllowedDatesRange() {
    this.minDate = Date.toMoment(this.huntPreferences.dates[0]);
    this.maxDate = Date.toMoment(this.huntPreferences.dates[this.huntPreferences.dates.length - 1]);
  }

  updateStartTimelines() {
    this.startTimelines = [];
    let timelines = this.huntPreferences.timelines
    const pickedToday = this.date.equals(Date.today())
    const now = Time.now();
   
    for (let timeline of timelines) {
      if (pickedToday && now.greaterThen(timeline.start)) {
        continue;
      } else {
        this.startTimelines.push(timeline);
      }
    }
  }

  updateFinishTimelines() {
    this.finishTimelines = [];
    for (let timeline of this.huntPreferences.timelines) {
      if (this.startTimelineId <= timeline.id) {
        if (this.finishTimelines.length >= this.allowedTimelinesCount) {
          break;
        }
        this.finishTimelines.push(timeline);
      }
    }
  }

  timelinesRange(startTimelineId: number, finishTimelineId: number): Array<Timeline> {
    const range = [];
    for (const timeline of this.huntPreferences.timelines) {
      if (startTimelineId <= timeline.id && finishTimelineId >= timeline.id) {
        range.push(timeline);
      }
    }
    return range;
  }

  onSubmit() {
    let desiredConference = new Conference();
    desiredConference.date = this.date;
    desiredConference.timelines = this.timelinesRange(this.startTimelineId, this.finishTimelineId)
    this.search.emit(desiredConference);
  }
}


// WEBPACK FOOTER //
// ./src/app/hunt/components/hunt-form/hunt-form.component.ts